<template>
  <modal :visible="visible" @on-close="onClose()">
    <template v-slot:body>
      <div class="table-responsive">
        <!-- <div class="head-info m-2">
          <h6>{{ order.company }} - {{ order.createdAt }}</h6>
        </div> -->
        <table
          v-if="products.length"
          class="table table-bordered table-striped"
        >
          <thead>
            <tr>
              <th>
                {{ $t("products.document") }}
              </th>
              <!-- <th>
                {{ $t("products.salesPerson") }}
              </th> -->
              <th>
                {{ $t("products.customer") }}
              </th>
              <th>
                {{ $t("products.dateAccounting") }}
              </th>
              <th>
                {{ $t("products.paymentDate") }}
              </th>
              <th>
                {{ $t("products.description") }}
              </th>
              <th>
                {{ $t("products.quantity") }}
              </th>
              <th>
                {{ $t("products.price") }}
              </th>
              <th>
                {{ $t("products.summaryAmount") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="product in products" :key="product.docEntry">
              <td>
                {{ product.docDate }}
              </td>
              <td>
                {{ product.overdue }}
              </td>
              <td>
                {{ product.message }}
              </td>
              <td>
                {{ product.docDueDate }}
              </td>
              <td>
                {{ product.net }}
              </td>
              <td>
                {{ parseFloat(product.gross) }}
              </td>
              <td>
                  {{ currencyDisplay(getPrice(product), false) }}
              </td>
              <td>
                {{ currencyDisplay(getPrice(product) * parseFloat(product.gross), false) }}
                <!-- {{
                  currencyDisplay(
                    parseFloat(product.gross) * parseFloat(product.docEntry),
                    false
                  )
                }} -->
              </td>
              <!-- <td>
                {{ parseInt(product.quantity) }}
              </td> -->
              <!-- <td>
            </td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <template v-slot:footer>
      <button class="btn" @click="onClose()">
        {{ $t("buttons.close") }}
      </button>
    </template>
  </modal>
</template>

<script>
import { currencyMixin } from "../mixins";
import Modal from "./Modal";
export default {
  name: "SalesReportsDetailsModal",
  components: {
    Modal,
  },
  mixins: [currencyMixin],
  props: {
    productsDetails: {
      type: Array,
      required: false,
      default: () => ({}),
    },
    visible: Boolean,
  },
  computed: {
    products() {
      if (this.productsDetails) {
        return this.productsDetails;
        // return this.order.products.map((productObject) => ({
        //   ...productObject.product[0],
        //   quantity: productObject.product[0].quantity,
        // }));
      } else {
        return [];
      }
    },
  },

  methods: {
     getPrice(product) {
      switch (product.currency) {
        case "EUR":
          return product.balance ;//parseFloat(product.dayAfter) + " " + product.currency;
          break;
        case "USD":
          return product.saldoServices;//parseFloat(product.docEntry) + " " + product.currency;
          break;
        case "PLN":
          return product.docEntry;//parseFloat(product.gross) + " " + product.currency;
          break;
        default:
        // code block
      }
    },
    onClose() {
    //   this.productsDetails = [];
      this.$emit("on-close");
    },
  },
};
</script>
